const WORDS = [
  "YORK",
  "HANOVER",
  "LANCASTER",
  "HARRISBURG",
  "GETTYSBURG",
  "HERSHEY",
  "CARLISLE",
  "MECHANICSBURG",
  "BALTIMORE",
  "TOWSON",
  "FREDERICK",
  "WESTMINSTER",
  "COLUMBIA",
  "ANNAPOLIS",
  "SILVER SPRING",
  "ROCKVILLE",
];

export const Marquee = () => {
  const loop = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee-section"
      className="bg-[#C05746] text-[#F9F7F4] border-y border-[#A64B3C] py-5 overflow-hidden"
    >
      <div className="flex gap-12 whitespace-nowrap animate-marquee will-change-transform">
        {loop.map((w, i) => (
          <div key={i} className="flex items-center gap-12">
            <span className="font-display text-xl md:text-2xl tracking-[0.12em]">{w}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#F9F7F4]/70" />
          </div>
        ))}
      </div>
    </section>
  );
};
